import * as React from 'react'
import {formatPercentage} from "@ui-seeker/utils";
import { Box } from "@mui/material"


export default function stockColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {formatPercentage(value)}
            </Box>
		}
	}
}